export interface BarisTeksResep {
  teks: string;
  kataKunci: string;
}

export interface IsiTempelanResep {
  items: any[];
  racikan: any[];
}

const KATA_BUKAN_NAMA = new Set([
  "TAB",
  "TABLET",
  "KAPSUL",
  "CAPS",
  "CAP",
  "SYR",
  "SIRUP",
  "INJ",
  "AMP"
]);

export function barisRDariTeks(
  teks: string | null | undefined
): BarisTeksResep[] {
  return String(teks || "")
    .split(/\r?\n/)
    .map(baris => baris.trim())
    .filter(baris => /^R\s*\//i.test(baris))
    .map(baris => {
      const isi = baris
        .replace(/^R\s*\/\s*/i, "")
        .replace(/\bNo\.?\s*[IVXLCDM\d]+.*$/i, "")
        .trim();
      const kata = isi
        .split(/\s+/)
        .find(
          satu =>
            /^[A-Za-z][A-Za-z-]{2,}$/.test(satu) &&
            !KATA_BUKAN_NAMA.has(satu.toUpperCase())
        );
      return { teks: baris, kataKunci: kata || isi.split(/\s+/)[0] || "" };
    })
    .filter(baris => baris.kataKunci !== "");
}

export function tempelanDariResep(resep: any): IsiTempelanResep {
  const items = (Array.isArray(resep?.items) ? resep.items : [])
    .filter((item: any) => !item.r && !item.stopped_at && item.obat_id)
    .map((item: any) => ({
      ...item,
      id: null,
      alasan_melebihi_jkn: null,
      alasan_aptol: null,
      aptol_status: null
    }));

  const racikan = (Array.isArray(resep?.racikan) ? resep.racikan : [])
    .map((header: any) => ({
      ...header,
      id: null,
      items: (Array.isArray(header.items)
        ? header.items
        : []
      ).map((item: any) => ({ ...item, id: null }))
    }))
    .filter((header: any) => header.items.length > 0);

  return { items, racikan };
}

export function labelTempelan(resep: any): string {
  const waktu = String(resep?.created_at || resep?.tanggal || "").slice(0, 10);
  const [tahun, bulan, hari] = waktu.split("-");
  const tanggal = tahun && bulan && hari ? `${hari}-${bulan}-${tahun}` : "";
  const dokter = resep?.dokter?.nama ? ` (${resep.dokter.nama})` : "";
  return `Ditempel dari resep ${tanggal}${dokter}`.trim();
}

const KOLOM_TERSTRUKTUR = [
  "dosis_qty",
  "satuan_dosis_id",
  "signa_bebas",
  "aturan_tambahan_ids",
  "aturan_pakai_text"
];

export function tanpaKolomTerstruktur(item: any): any {
  const salinan = { ...item };
  KOLOM_TERSTRUKTUR.forEach(kolom => {
    delete salinan[kolom];
  });
  return salinan;
}
